<template>
  <div>
    <form>
      <v-row>
        <v-col
          ><v-avatar color="orange"><v-img src="../assets/logo-lumoe.png"/></v-avatar
        ></v-col>
        <v-col cols="8">
          <v-text-field
            class="mr-7"
            dense
            v-model="searchText"
            label="Search by MIRN or Meter Number or Address"
            required
            @input="throttledSubmit"
            outlined
          ></v-text-field>
        </v-col>
        <v-switch v-model="isShowCheckSum" label="Show Checksum"></v-switch>

        <v-col cols="1">
          <v-btn class="primary" @click="clear">clear</v-btn>
        </v-col>
      </v-row>
    </form>
    <v-progress-linear v-if="isLoading" indeterminate />
    <DisplayResults
      v-if="results && results.length > 0"
      :isShowCheckSum="isShowCheckSum"
      :results="results"
    ></DisplayResults>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { searchRequest } from '../api/http';
import DisplayResults from './DisplayResults';
import _ from 'lodash';
export default {
  name: 'SearchAndDisplay',
  components: { DisplayResults },
  data: () => ({
    searchText: null,
    results: [],
    isShowCheckSum: false,
  }),
  computed: {
    ...mapState(['isLoading']),
  },
  methods: {
    throttledSubmit: _.debounce(function() {
      if (this.searchText.length >= 4) {
        this.results = null;
        searchRequest(this.searchText).then(resp => {
          this.results = resp.data;
        });
      }
    }, 500),
    clear() {
      this.searchText = null;
      this.results = null;
      this.isShowCheckSum = false;
    },
  },
};
</script>
